export default [
  {
    header: 'Projects',
  }, 
  {
    title: 'Projects overview',
    route: 'projects',
    icon: 'LayoutIcon',
  }
]